const API_URL = "https://" + process.env.VUE_APP_API_HOST;

export async function loadImageAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => resolve({
      base64: e.target.result.split(',')[1],
      mimeType: file.type
    });
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

export async function readTemperature(base64, mimeType) {
  const token = localStorage.getItem("token");
  const response = await fetch(`${API_URL}/api/temperature/read_image`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    },
    body: JSON.stringify({ base64, mimeType }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `Server error ${response.status}`);
  }

  const data = await response.json();
  return data.temperature;
}
